import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { GroupFeatureMapCompartments, groupFeatureMapStorageKey } from '..';

export class GroupFeatureMapListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.GroupSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(groupFeatureMapStorageKey)
    private readonly cache: DataCache<GroupFeatureMapCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('groupFeatureMap');
        } else {
          this.cache.reset('groupFeatureMap');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
